module.exports = __webpack_public_path__ + "static/media/rightmain.7e9bf0a3.png";